export const preventSubmitOnEnter = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.key === "Enter") {
        if (!(e.target instanceof Element && e.target.tagName === "TEXTAREA")) {
            e.preventDefault()
        }
    }
}
